import React, { useEffect, useState , useRef} from "react";
import { useLocation } from "react-router-dom";
import BookingForm from "./bookingForm";
import Card from "./Card";
import Hero from "./Hero";
import QuickSelection from "./QuickSelection";
import Recommended from "./recommended";
import Install from "../PWA/install";

let deferredPrompt;

const isSmallScreen = () => window.matchMedia("(max-width: 767px)").matches;

const Index = () => {
  const [installable, setInstallable] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
   const [isModalOpen, setIsModalOpen] = useState(false);

  const userid = localStorage.getItem("userID")?.replace(/"/g, "");
const [isMobile, setIsMobile] = useState(isSmallScreen());

useEffect(() => {
  const handler = () => setIsMobile(isSmallScreen());
  window.addEventListener("resize", handler);
  return () => window.removeEventListener("resize", handler);
}, []);

 
  const [prefillData, setPrefillData] = useState({});
useEffect(() => {
  if (!userid) {
    const storedData = JSON.parse(localStorage.getItem("prefillRoute") || "{}");
    if (Object.keys(storedData).length > 0) {
      setPrefillData(storedData);
    }

    // clear on refresh/unmount
    const handleUnload = () => {
      localStorage.removeItem("prefillRoute");
    };
    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }
}, [userid]);

    


  const handleInstallClick = () => {
    setInstallable(false);
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
         
        } else {
        
        }
        deferredPrompt = null;
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      setInstallable(true);
    };

    const handleAppInstalled = () => {};

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleCloseClick = () => {
    setInstallable(false);
  };

   useEffect(() => {
   
    if (location.state?.scrollToBooking) {
      const el = document.getElementById("booking-form");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        // optional: autofocus pickupStreet for guest
        setTimeout(() => {
          const input = document.querySelector("input[name='pickupStreet']");
          input?.focus();
        }, 500);
      }
    }
  }, [location.state]);

  

  return (
    <>
       {/* inline CSS inside component */}
      <style>{`
        .page-content {
          transition: filter 0.3s ease;
        }
        .page-content.blurred {
          filter: blur(6px);
          pointer-events: none;
        }
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.3);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .modal-content {
          background: #fff;
          padding: 20px;
          border-radius: 12px;
          width: 90%;
          max-width: 500px;
          max-height: 80vh;
          overflow-y: auto;
        }
      `}</style>
 <div className={`${installable ? 'pb-48' : ''}`} style={{ fontFamily: 'Lato, sans-serif' }}>
  {/* ✅ Blur applied to the whole app content */}
  <div className={`page-content ${isModalOpen ? "blurred" : ""}`}>
    <Hero />

    {/* Recommended in normal flow */}
    <div className="w-full max-w-3xl mx-auto p-6">
      <Recommended setIsModalOpen={setIsModalOpen}/>
    </div>

    <div className="h-40"></div>
    <BookingForm />
  </div>
</div>


     {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Recommended Ride</h2>
            <p>Details about the recommended ride…</p>
            <button onClick={() => setIsModalOpen(false)}>Close</button>
          </div>
        </div>
      )}

   {installable && isMobile && (
  <div className="fixed bottom-0 left-0 w-full bg-white shadow-lg px-4 py-3 z-[9999] font-lato">
    <Install
      installable={installable}
      onInstallClick={handleInstallClick}
      onCloseClick={handleCloseClick}
    />
  </div>
)}
      </>
   
  );
};

export default Index;
